import styled from "styled-components";

export const StyledNav = styled.div`
  margin-left: 20px;
`;

export const StyledNavMobile = styled.div`
  display: flex;
  flex-direction: column;
`;
